export const columna = [

	

   {
		"nombre": "Noticias.",
		"imagen": 'noticias/huejutlacapacitacion.jpg',
	   "funcion": 'Comités de Contraloría Social.',
		"url" : 'https://www.facebook.com/reel/1573236044404630',
	},


	{
		"nombre": "Noticias.",
		"imagen": 'noticias/podpueblo.jpg',
	    "funcion": 'El Podcast del Pueblo.',
		"url" : 'https://www.facebook.com/reel/1796940961676365',
	},

	
	{
		"nombre": "Noticias.",
		"imagen": 'noticias/sesenta.jpg',
	    "funcion": '60 segundos.',
		"url" : 'https://www.facebook.com/reel/1593741799066798',
	},

	{
		"nombre": "Noticias.",
		"imagen": 'noticias/buzón.jpg',
		"funcion": "Buzón Digital",
		"url": "https://buzondigitalcontraloria.hidalgo.gob.mx/"
	},

	// // {
	// 	"nombre": "Podcast del Pueblo",
	// 	"imagen": 'noticias/comisarios.jpg',
	// 	"funcion": '"Hidalgo Honesto"',
	// 	"url" : 'https://www.facebook.com/100064535929070/videos/755046710063599/?__so__=permalink&locale=es_LA',
	// },
		



]